import Vue from 'vue';
import App from './App.vue';

Vue.config.productionTip = false;

const getUrlParams = () => {
  const params = {};
  window.location.href.replace(/[?&]+([^=&]+)=([^&]*)/gi, (m, key, value) => {
    params[key] = value;
  });
  return params;
};

const checkParamsAndRedirect = () => {
  const params = getUrlParams();

  const { id } = params;


  document.title = 'Privacy Policy';

  if (id && id.toLowerCase().indexOf('4yh') >= 0) {
    window.location.href = `./4yh/${window.location.search}${window.location.hash}`;
  } else if (id && id.toLowerCase().indexOf('sp') >= 0) {
    window.location.href = `./sp/${window.location.search}${window.location.hash}`;
  }
};

checkParamsAndRedirect();

new Vue({
  render: h => h(App, { props: getUrlParams() }),
}).$mount('#app');
